import React from 'react';
import useModals from '../../utils/useModals';
import { Button, ModalContainer } from '../Common';
import './DemoPage.scss';

const DemoPage = () => {

  const modals = useModals();

  return (
    <div className="app-page-component">
      <h1 id="app_page_title">Demo Page</h1>

      <h3>Button Types</h3>
      <section title="Button Types">
        <Button isNew text='Primary Button' />
        <Button isNew text='Secondary Button' appearance='secondary' />
        <Button isNew text='Disabled Button' appearance='disabled' />
      </section>

      <section title="Button Sizes">
        <Button isNew text='Large' size='large' />
        <Button isNew text='Medium' />
        <Button isNew text='Small' size='small' />
      </section>

      <section title="Button Sizes">
        <Button isNew text='Large' size='large' appearance='secondary' />
        <Button isNew text='Medium' appearance='secondary' />
        <Button isNew text='Small' size='small' appearance='secondary' />
      </section>

      <section title="Button Sizes">
        <Button isNew text='Large' size='large' appearance='disabled' />
        <Button isNew text='Medium' appearance='disabled' />
        <Button isNew text='Small' size='small' appearance='disabled' />
      </section>

      <section title="Button Sizes">
        <div>
          <Button isNew text='Large - Expanded' stretch />
          <Button isNew text='Large - Expanded' appearance='secondary' stretch />
          <Button isNew text='Large - Expanded' appearance='disabled' stretch />
        </div>
        <div>
          <Button isNew text='Small - Expanded' size='small' stretch />
          <Button isNew text='Small - Expanded' size='small' appearance='secondary' stretch />
          <Button isNew text='Small - Expanded' size='small' appearance='disabled' stretch />
        </div>
      </section>

      <h3>Modals</h3>
      <section title="Modals">
        <Button isNew text='Open Small Modal' onClick={() => modals.openModal('sm')} />
        <ModalContainer
          isOpen={modals.visibleModal === 'sm'}
          onCancel={modals.closeModal}
          size='small'
          title='This is the small dialog'
          text='Disabling will prevent <b>a.miller@gmail.com</b> from
            accessing Analytics by Liaison and all permissions will
            be removed. You may not edit or impersonate disabled
            users' />
        <Button isNew text='Open Medium Modal' onClick={() => modals.openModal('md')} />
        <ModalContainer
          isOpen={modals.visibleModal === 'md'}
          onCancel={modals.closeModal}
          size='medium'
          title='This is the medium dialog'
          text='Disabling will prevent <b>a.miller@gmail.com</b> from
            accessing Analytics by Liaison and all permissions will
            be removed. You may not edit or impersonate disabled
            users' />
      </section>


    </div>
  )
}

export default DemoPage
